import { DynamicForm, FieldVariant, SelectOption } from '../../../../components/form-builder/form-builder.types';
import { CompanyRepository } from '../../../../store/company-state/company-state.repository';

interface getCompanyFormObjectProps {
  store: CompanyRepository;
  companiesTypesOptions?: SelectOption[];
  companyCategoriesOptions?: SelectOption[];
}

export const getCompanyFormObject = ({ store, companiesTypesOptions, companyCategoriesOptions }: getCompanyFormObjectProps): DynamicForm => {
  const nameField = {
    label: 'settings.companyInfo.form.name.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'nom'),
      onChange: (value: string) => {
        store.setNested('dto', 'nom', value);
      },
    },
  };
  const typeField = {
    label: 'settings.companyInfo.form.type.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.companyInfo.form.type.placeholder',
      options: companiesTypesOptions,
      value: store.getObservable('companyTypeSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'typeId', value.code);
        store.set('companyTypeSelected', value);
      },
    },
  };

  const nniField = {
    label: 'settings.companyInfo.form.nni.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'nni'),
      onChange: (value: string) => {
        store.setNested('dto', 'nni', value);
      },
    },
  };
  const submissionCategoryField = {
    label: 'settings.companyInfo.form.categorySoumissionnaire.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'settings.companyInfo.form.categorySoumissionnaire.placeholder',
      options: companyCategoriesOptions,
      value: store.getObservable('companyCategorySelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'categorieSoumissionnaireId', value.code);
        store.set('companyCategorySelected', value);
      },
    },
  };

  return {
    title: 'Company',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nameField, typeField],
          },
          {
            fields: [nniField, submissionCategoryField],
          },
        ],
      },
    ],
  };
};
